import axios from "axios";
import AppConfig from "./app-config";
import toast from "react-hot-toast";

const axiosInstance = axios.create({
  baseURL: AppConfig.api_baseurl,
  timeout: 10000, // Set a timeout limit for requests
  headers: AppConfig.headers,
});


// Request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    // Add any custom logic before the request is sent
    const token = localStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    // Handle request error
    return Promise.reject(error);
  }
);

// Response interceptor
// axiosInstance.interceptors.response.use(
//   (response) => {
//     // Any custom logic for handling successful responses
//     return response;
//   },
//   (error) => {
//     if (error.response && error.response.status === 401) {
//       // Example: Redirect to login if unauthorized
//       localStorage.clear();
//       window.location.href = "/";
//       window.location.reload();
//     }
//     return Promise.reject(error);
//   }
// );

// axiosInstance.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     console.log
//     if (error.response) {
//       const { status, data } = error.response;

//       if (status === 401) {
//         localStorage.clear();
//         window.location.href = "/";
//         window.location.reload();
//       } else if (data && data.error) {
//         // Check if `data.error` has nested objects
//         const errorContent = typeof data.error === "object" ? data.error : { general: [data.error.toString()] };

//         Object.values(errorContent).forEach((nestedError) => {
//           // Handle each nested error (e.g., `guest`)
//           if (typeof nestedError === "object") {
//             Object.values(nestedError).forEach((errorMessages) => {
//               if (Array.isArray(errorMessages)) {
//                 errorMessages.forEach((msg) => toast.error(msg));
//               } else {
//                 toast.error(errorMessages.toString()); // Convert non-array values to string
//               }
//             });
//           } else {
//             toast.error(nestedError.toString());
//           }
//         });
//       } else {
//         toast.error("An unexpected error occurred.");
//       }
//     } else {
//       toast.error("Network error. Please try again.");
//     }

//     return Promise.reject(error);
//   }
// );


// axiosInstance.interceptors.response.use(
//   (response) => {
//     return response;
//   },
//   (error) => {
//     if (error.response) {
//       const { status, data } = error.response;

//       switch (status) {
//         case 401:
//           localStorage.clear();
//           break;
//         case 403:
//           toast.error("Forbidden access. You don't have permission.");
//           break;
//         case 404:
//           toast.error("Resource not found.");
//           break;
//         case 500:
//           toast.error("Internal server error. Please try again later.");
//           break;
//         default:
         
//       }

//       return error.response;
//     } else if (error.request) {
    
//       toast.error("No response from the server. Please check your connection.");  
//       return error.request
//     } else {
    
//       toast.error("Request failed. Please try again.");
//     }
   
//   }
// );
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    
    if (error.response) {
      const { status, data ,statusText} = error.response;
      
      if (status === 401) {
        localStorage.clear();
        window.location.href = "/";
        window.location.reload();
      } else if(status === 500){
        toast.error("Internal Server Error.");
      }else if (data && data?.error) {
       

        const errors = Object.values(data?.error || {});
const firstError = Array.isArray(errors[0]) ? errors[0][0] : errors[0];

if (firstError) toast.error(firstError);
        
      } else {
        toast.error("An unexpected error occurred.");
      }
    } else {
      toast.error("Network error. Please try again.");
    }

    return Promise.reject(error);
  }
);


export default axiosInstance;
